'use client';

import { ThemeProvider as NextThemesProvider } from 'next-themes';
import { usePathname } from 'next/navigation';
import type { ComponentProps } from 'react';

// 路由级固定主题（next-themes forcedTheme）：仅影响挂载期间的 DOM 展示，
// 不读写用户主题偏好（localStorage / cookie），离开路由自动还原；
// portal 到 body 的内容（Dialog/Popover/Toast）同样生效。
const ROUTE_FORCED_THEME: ReadonlyArray<readonly [RegExp, 'light' | 'dark']> = [
  [/^\/router(\/|$)/, 'light'],
  [/^\/market(\/|$)/, 'light'],
  [/^\/studio(\/|$)/, 'dark'],
  [/^\/demo(\/|$)/, 'dark'],
];

export const ThemeProvider = (
  props: ComponentProps<typeof NextThemesProvider>
) => {
  const pathname = usePathname() ?? '';
  const routeForced = ROUTE_FORCED_THEME.find(([re]) => re.test(pathname))?.[1];

  return (
    <NextThemesProvider
      {...props}
      forcedTheme={props.forcedTheme ?? routeForced}
    />
  );
};
